module.exports = __webpack_public_path__ + "img/Add_round_light.49fb4fd1.svg";